import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import Links from "../sub-components/Links";

const { PUBLIC_URL } = process.env;
const Feature1 = () => {
  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  const [activeIndex, setActiveIndex] = useState(0);

  const handleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      {/* section1 */}

      <section className="section main-banner" id="f1top">
        <video autoPlay muted loop id="bg-video">
          <source src={dashboard_Video} type="video/mp4" />
        </video>

        <div className="video-overlay header-text">
          <div className="caption">
            <h4 style={{ color: "#f5a425" }}>
              CREATE SKILLS AND <br />
              KNOWLEDGE ASSESSMENTS
            </h4>
            <h6>
              Make insightful evaluations. Assess skills and knowledge of
              <br />
              your respondents to gain deep result analytics.
            </h6>

            <div className="main-button">
              <div className="scroll-to-section">
                <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section2 */}
      <section className="dark-bg">
        <div className="container-fluid dark-bg-sec">
          <div className="row sec2">
            <div className="col-lg-12 diffneeds ">
              <h4>Different needs - one assessment solution</h4>
              <h2>Assessment methods for all your needs</h2>
            </div>

            <div className="col-lg-4 quizzes">
              <h3>QUIZZES</h3>
              <p>
                Create short, informal assessments with up to 10 simple
                questions, perfect for business and educational needs. Gain
                actionable insights and make informed decisions with ease.
                Explore our intuitive quiz builder now.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">Learn more</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 quizzes">
              <h3>TESTS</h3>
              <p>
                Design more complex, formal, and longer online assessments using
                a platform that blends efficiency with strong security. Analyze
                results and meet your assessment needs. NexTestify is your ideal
                test builder.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">Learn more</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 quizzes">
              <h3>EXAMS</h3>
              <p>
                Design long, demanding, and comprehensive online exams and
                certifications. Enhance them instantly with insightful data and
                better efficiency. NexTestify guarantees unmatched security and
                reliability in all results.
              </p>

              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">Learn more</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section3 */}
      <section className="img-bg">
        <div className="container-fluid img-bg-sec">
          <div className="row sec3">
            <div className="col-lg-12 asses">
              <h4>
                Create online assessments <br />
                for impressive data
              </h4>
            </div>

            <div className="col-lg-6 asses-col1">
              <ul>
                {activeIndex === 0 ? (
                  <div className="panel">
                    <li
                      onClick={() => handleAccordion(0)}
                      style={{
                        color: "#f5a425",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      Individual and collective respondent results
                      <MdKeyboardArrowUp />
                    </li>
                    <p>
                      Access all results to see insightful, actionable details.
                      NexTestify is an online test creation platform that offers
                      cutting-edge, easy-to-use filtering and sorting options.
                    </p>
                    {/* <p style={{ color: "#f5a425" }}>
                        Read more <GoArrowRight />
                      </p> */}
                  </div>
                ) : (
                  <li
                    className="accordion"
                    onClick={() => handleAccordion(0)}
                    style={{ cursor: "pointer", fontWeight: "500" }}
                  >
                    Individual and collective respondent results{" "}
                    <MdKeyboardArrowDown />
                  </li>
                )}

                {activeIndex === 1 ? (
                  <div className="panel">
                    <li
                      onClick={() => handleAccordion(1)}
                      style={{
                        color: "#f5a425",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      Statistics <MdKeyboardArrowUp />
                    </li>
                    <p>
                      Make data-driven decisions with insightful statistics.
                      Clearly see the distinction between the easy and demanding
                      sections of your assessments.
                    </p>
                    {/* <p style={{ color: "#f5a425" }}>
                        Read more <GoArrowRight />
                      </p> */}
                  </div>
                ) : (
                  <li
                    className="accordion"
                    onClick={() => handleAccordion(1)}
                    style={{ cursor: "pointer", fontWeight: "500" }}
                  >
                    Statistics <MdKeyboardArrowDown />
                  </li>
                )}

                {activeIndex === 2 ? (
                  <div className="panel">
                    <li
                      onClick={() => handleAccordion(2)}
                      style={{
                        color: "#f5a425",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      {" "}
                      Live monitoring and results table <MdKeyboardArrowUp />
                    </li>
                    <p>
                      Be a part of the process and observe real-time analytics
                      of your respondents’ progress.
                    </p>
                    {/* <p style={{ color: "#f5a425" }}>
                        Read more <GoArrowRight />
                      </p> */}
                  </div>
                ) : (
                  <li
                    className="accordion"
                    onClick={() => handleAccordion(2)}
                    style={{ cursor: "pointer", fontWeight: "500" }}
                  >
                    {" "}
                    Live monitoring and results table <MdKeyboardArrowDown />
                  </li>
                )}

                {activeIndex === 3 ? (
                  <div className="panel">
                    <li
                      onClick={() => handleAccordion(3)}
                      style={{
                        color: "#f5a425",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      {" "}
                      Progress statistics <MdKeyboardArrowUp />
                    </li>
                    <p>
                      Compare insights from various assessments to conveniently
                      detect all learning trends and patterns.
                    </p>
                    {/* <p style={{ color: "#f5a425" }}>
                        Read more <GoArrowRight />
                      </p> */}
                  </div>
                ) : (
                  <li
                    className="accordion"
                    onClick={() => handleAccordion(3)}
                    style={{ cursor: "pointer", fontWeight: "500" }}
                  >
                    {" "}
                    Progress statistics <MdKeyboardArrowDown />
                  </li>
                )}

                {activeIndex === 4 ? (
                  <div className="panel">
                    <li
                      onClick={() => handleAccordion(4)}
                      style={{
                        color: "#f5a425",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      Reports <MdKeyboardArrowUp />
                    </li>
                    <p>
                      Insightful data comparisons, all in one place. Impressive
                      versatility and accuracy of information.
                    </p>
                    {/* <p style={{ color: "#f5a425" }}>
                        Read more <GoArrowRight />
                      </p> */}
                  </div>
                ) : (
                  <li
                    className="accordion"
                    onClick={() => handleAccordion(4)}
                    style={{ cursor: "pointer", fontWeight: "500" }}
                  >
                    Reports <MdKeyboardArrowDown />
                  </li>
                )}
              </ul>
            </div>

            <div className="col-md-12 col-lg-6 sec3img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/Results-Page1.jpeg`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                    alt=""
                    className="overlay-image1"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image2"
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image3"
                  />
                </figure>
              </article>
            </div>
            {/* </div> */}
          </div>
        </div>
      </section>

      {/* section4 */}

      <section className="dark-bg2">
        <div className="container-fluid dark-bg2-sec">
          <div className="row sec4">
            <div className="col-md-12 col-lg-6 sec4img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/Test-page.png.png`}
                    alt=""
                    className=".main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_l_r.svg`}
                    alt=""
                    className="green_l_r"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_r_l.svg`}
                    alt=""
                    className="green_r_l"
                  />
                </figure>
              </article>
            </div>

            <div className="col-lg-6 sec4text">
              <h3>Only accurate and reliable assessment results</h3>
              <p>
                NexTestify measures evaluation time on the server-side to
                eliminate any cheating attempts. No test time tweaking is
                possible, so the results will always reflect your respondents'
                knowledge.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* section5 */}

      <section className="light-bg">
        <div className="container-fluid light-bg-sec">
          <div className="row sec5">
            <div className="col-lg-12 sec5text">
              <h4>Diverse question options for thorough assessments</h4>
              {/* <a style={{ color: "#ff9d00" }}>
                  Read more <GoArrowRight />
                </a> */}
            </div>

            <div className="col-lg-6 sec5list">
              <ul>
                <li>
                  <div className="sec5listdiv">
                    <h3>Single and multiple-choice questions</h3>
                    <p>
                      Include single and multiple-choice questions to assess
                      various fields of expertise. Receive immediate, aggregated
                      responses from every respondent.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="sec5listdiv">
                    <h3>Self grading short answer questions</h3>
                    <p>
                      Go beyond choice questions for detailed insights from all
                      participants. Save time with NexTestify's excellent
                      self-grading open-ended questions.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="sec5listdiv">
                    <h3>Descriptive open-ended questions</h3>
                    <p>
                      Require descriptive information about specific areas of
                      knowledge. Grade responses yourself for in-depth analysis
                      and maximum reliability.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-md-12 col-lg-6 sec5img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/tp3-1.png`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/purple_curve_bottom.svg`}
                    alt=""
                    className="purple_curve_bottom"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow_curve_top.svg`}
                    alt=""
                    className="yellow_curve_top"
                  />
                </figure>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* section6 */}

      <section className="img-bg">
        <div className="container-fluid img-bg-sec">
          <div className="row sec6">
            <div className="col-md-12 col-lg-6 sec6img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/tp4-1.png`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                    alt=""
                    className="overlay-image1"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image2"
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image3"
                  />
                </figure>
              </article>
            </div>

            <div className="col-lg-6 sec6text">
              <h3>Complete control over question sets and order</h3>
              <p>
                NexTestify's advanced drawing algorithms allow you to easily
                prepare an online test and configure the randomization of full
                or partial questions. You can choose predefined test sets, a
                fixed order of tasks, and much more.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">Read more</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section7 */}

      <section className="dark-bg">
        <div className="container-fluid dark-bg-sec">
          <div className="row sec7">
            <div className="col-lg-6 sec7text">
              <h3>
                No account needed to access <br />
                assessments. Test-taking made simple.
              </h3>
              <p>
                Test access for the respondents is simple and hassle-free. No
                NexTestify account is needed to start an online evaluation. In
                case of any interruptions, participants can save the test and
                continue it later.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">Read more</a>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 sec7img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/tp5-1.png`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/purple_curve_bottom.svg`}
                    alt=""
                    className="purple_curve_bottom"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow_curve_top.svg`}
                    alt=""
                    className="yellow_curve_top"
                  />
                </figure>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* section8 */}

      <section className="img-bg">
        <div className="container-fluid img-bg-sec">
          <div className="row sec8">
            <div className="col-md-12 col-lg-6 sec8img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/tp6-1.png`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_top.svg`}
                    alt=""
                    className="green_curve_top"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_bottom.svg`}
                    alt=""
                    className="green_curve_bottom"
                  />
                </figure>
              </article>
            </div>

            <div className="col-lg-6 sec8text">
              <h3>Test results you can trust</h3>
              <p>
                Ensure full reliability and accountability of all your
                assessments. NexTestify offers powerful, yet simple and
                affordable proctoring techniques that are effortless to
                implement.
              </p>

              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">Read more</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section9 */}

      <section className="light-bg">
        <div className="container-fluid light-bg-sec">
          <div className="row sec9">
            <div className="col-lg-12 sec9text">
              <h4>
                Reliable, actionable feedback. Tailored to your <br />
                needs.
              </h4>
              {/* <a style={{ color: "#f5a425", fontSize: "20px" }}>
                  Read more <GoArrowRight />
                </a> */}
            </div>

            <div className="col-lg-6 sec9list">
              <ul>
                <li>
                  <div className="sec9listdiv">
                    <h3>Automated feedback</h3>
                    <p>
                      Respondents receive immediate, predefined feedback after
                      completing the test. Many options are available, and can
                      all be adjusted to your needs.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="sec9listdiv">
                    <h3>
                      Personalized feedback to an entire test or individual
                      questions
                    </h3>
                    <p>
                      Include a detailed summary of the entire test or reveal
                      feedback only on specific questions after the respondent
                      completes their tasks.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="sec9listdiv">
                    <h3>Two-stage feedback</h3>
                    <p>
                      All summary options available on NexTestify can be set to
                      a two-stage mode. Some feedback will then be released
                      initially to the respondent, and the rest available only
                      after a review by the test owner.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-md-12 col-lg-6 sec9img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/tp7-1.png`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/purple_curve_bottom.svg`}
                    alt=""
                    className="purple_curve_bottom"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow_curve_top.svg`}
                    alt=""
                    className="yellow_curve_top"
                  />
                </figure>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* section10 */}

      <section className="dark-bg2">
        <div className="container-fluid dark-bg2-sec">
          <div className="row sec10">
            <div className="col-md-12 col-lg-6 sec10img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/tp8.webp`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                    alt=""
                    className="overlay-image1"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image2"
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image3"
                  />
                </figure>
              </article>
            </div>
            <div className="col-lg-6 sec10text">
              <h3>
                Predefined or customized <br />
                certificates. All up to you.
              </h3>
              <p>
                NexTestify offers ready-made certificates that only have to be
                filled in with basic data. Alternatively, you can opt for full
                customization if you have specific needs and requirements.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">Read more</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section11 */}

      <section className="img-bg">
        <div className="container-fluid img-bg-sec sectionlast">
          <div className="row sec11">
            <div className="col-lg-6 sec11text">
              <h3>
                Access on any device, <br />
                anytime and from anywhere
              </h3>
              <p>
                Access to all features of our platform really couldn't be more
                convenient. NexTestify is available on all computers and mobile
                devices, both as a stand-alone app and a Microsoft Teams add-in.
              </p>
            </div>
            <div className="col-md-12 col-lg-6 sec11img">
              <article className="video-item">
                <figure className="image-container">
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/tp9.webp`}
                    alt=""
                    className="main-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_l_r.svg`}
                    alt=""
                    className="green_l_r"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_r_l.svg`}
                    alt=""
                    className="green_r_l"
                  />
                </figure>
              </article>
            </div>
          </div>
        </div>
      </section>

      <Links />
    </div>
  );
};

export default Feature1;
